export default function leftPad(value: string, length: number, character = '0') {
  if (value.length >= length) return value;

  return new Array(length - value.length).fill(character).join('') + value;
}